import { ultimoDiaDelMes } from "../../../../Helpers/FormatFecha";

// Ultimo dia del mes actual en formato yyyy-MM-dd (hora local).
export const getUltimoDiaMes = () => ultimoDiaDelMes();

export const handleChangeMoneda = (
  nuevaMoneda,
  setMoneda,
  setInfoCotizacion
) => {
  setMoneda(nuevaMoneda);

  // Actualizar moneda en infoCotizacion.detalle
  setInfoCotizacion((prev) => ({
    ...prev,
    detalle: prev.detalle.map((item) => ({
      ...item,
      moneda: nuevaMoneda,
    })),
  }));
};
